export default "__VITE_ASSET__Bt0ky3uz__"